import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ISite, IUser } from '../../models';
import { ISensor } from '../../models/sensor.interface';

@Injectable({
  providedIn: 'root'
})
export class SiteService {
  readonly endpoints = {
    getSites: `${environment.apiUrl}/organisation/{0}/sites`,
    getCameras: `${environment.apiUrl}/site/{0}/cameras`,
    registerSite: `${environment.apiUrl}/site`,
    updateSite: `${environment.apiUrl}/site`,
    deleteSite: `${environment.apiUrl}/SiteAPI/Delete`,
  }

  private http: HttpClient = inject(HttpClient);

  getSites(orgId: string): Observable<ISite[]> {
    return this.http.get<any>(this.endpoints.getSites.replace("{0}", orgId))
  }

  getCameras(siteId: string): Observable<ISensor[]> {
    return this.http.get<any>(this.endpoints.getCameras.replace("{0}", siteId))
  }

  registerSite(user: IUser, site: ISite): Observable<ISite> {
    let payload = {...site}
    payload["organisation_id"] = user.organisation_id

    return this.http.post<ISite>(this.endpoints.registerSite, payload)
  }

  updateSite(site: ISite): Observable<ISite> {
    let payload = {...site, "sensors": {}}
    return this.http.put<ISite>(this.endpoints.updateSite, payload)
  }

  deleteSite(site: ISite) {
    let payload = {
      id: site.id
    }
    return this.http.post(this.endpoints.deleteSite, payload)
  }
}
